import { createAction } from '@reduxjs/toolkit';

// Event Action of type Track
/* `const googleAnalytics4Event = createAction('googleAnalytics4/event');` is creating an action creator function using
the `createAction` function from the `@reduxjs/toolkit` library. This action creator function will
return an action object with a `type` property set to `'googleAnalytics4/event'` when it is called. This
action can then be dispatched to the Redux store to trigger a state update or other side effects. */
const googleAnalytics4Event = createAction('googleAnalytics4/event');

// Event Action of type Impression
/* `const googleAnalytics4Impression = createAction('googleAnalytics4/impression');` is creating an action creator
function using the `createAction` function from the `@reduxjs/toolkit` library. This action creator
function will return an action object with a `type` property set to `'googleAnalytics4/impression'` when it
is called. This action can then be dispatched to the Redux store to trigger a state update or other
side effects. */
const googleAnalytics4Impression = createAction('googleAnalytics4/impression');

export  { googleAnalytics4Event, googleAnalytics4Impression };
